__turbopack_context__.v({
  "nav": "FlywayFilterCarousel-module__dMdXQq__nav",
  "navButton": "FlywayFilterCarousel-module__dMdXQq__navButton",
  "navButtonIconStart": "FlywayFilterCarousel-module__dMdXQq__navButtonIconStart",
  "title": "FlywayFilterCarousel-module__dMdXQq__title",
  "titleViewport": "FlywayFilterCarousel-module__dMdXQq__titleViewport",
});
